import { Link } from 'react-router-dom';

export default function HomeHero() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Epic%20gaming%20arena%20with%20golden%20and%20crimson%20energy%20waves%2C%20dark%20atmospheric%20background%20with%20warm%20glowing%20particles%2C%20abstract%20competitive%20gaming%20vibe%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20dark%20warm%20tones%20with%20gold%20accents&width=1600&height=900&seq=hero-bg-lol-2026&orientation=landscape"
        alt="撸啊撸攻略大全 - 英雄联盟游戏竞技场景"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-500/20 border border-accent-500/30 mb-6">
          <i className="ri-fire-line text-accent-400 text-sm"></i>
          <span className="text-accent-300 text-sm font-medium">S14赛季最新攻略持续更新中</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 mb-6 leading-tight">
          撸啊撸攻略大全
          <span className="block text-primary-400 text-xl md:text-2xl lg:text-3xl mt-3 font-body font-normal">
            英雄技巧与段位提升指南
          </span>
        </h1>

        <p className="text-background-200/80 text-base md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
          汇聚撸啊撸英雄选择、出装攻略、对线技巧、团战策略与段位提升全套方案，
          助你快速从青铜迈向王者，找到最适合自己的玩法风格。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/hero-guide"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-lg font-medium text-base hover:bg-primary-600 transition-colors no-underline whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line mr-2"></i>
            开始学习攻略
          </Link>
          <Link
            to="/category/meta-tier"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50/10 text-background-50 border border-background-50/20 rounded-lg font-medium text-base hover:bg-background-50/20 transition-colors no-underline whitespace-nowrap cursor-pointer"
          >
            <i className="ri-fire-line mr-2"></i>
            查看版本强势英雄
          </Link>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { value: '200+', label: '攻略文章' },
            { value: '160+', label: '覆盖英雄' },
            { value: '50万+', label: '月活读者' },
            { value: '98%', label: '好评率' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="font-heading text-2xl md:text-3xl text-primary-400">{stat.value}</div>
              <div className="text-xs text-background-300/80 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}